import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { LenderPartners } from "@/components/site/LenderPartners";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { BlogPreview } from "@/components/site/BlogPreview";
import { BlogIndex } from "@/components/site/BlogIndex";
import { BlogPost } from "@/components/site/BlogPost";

const HomePage = () => (
  <main data-testid="home-page" className="font-body">
    <Header />
    <Hero />
    <LenderPartners />
    <Services />
    <Process />
    <About />
    <Testimonials />
    <BlogPreview />
    <FAQ />
    <Contact />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
